export default {
  "Table": "_Table_1i3b2_1"
};import "ni:sha-256;zuH51nVGW4vPYkaTv_rrlPbBRk_8z0JwvWdci1qELgg";